import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedThumbsDown: FunctionalComponent<IIconProps> = ({
  width = '16',
  height = '16',
  fill = '#666',
  selected = false,
  disabled = false,
}) => {
  return selected ? (
    /*@ts-ignore*/
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none">
      <path
        fill={disabled ? '#ccc' : selected ? '#bd3c37' : fill}
        fill-rule="evenodd"
        d="M11.483 21.588c-.541.548-1.418.548-1.969.01-.336-.335-.476-.809-.383-1.273l.887-4.512H5.477c-.47 0-.937-.093-1.369-.273-1.764-.735-2.58-2.719-1.825-4.432l2.535-5.744C5.183 4.536 6.02 4 6.947 4h7.738C15.965 4 17 5.007 17 6.25v8.68c0 .567-.22 1.114-.618 1.53l-4.9 5.128zM20.5 4c.825 0 1.5.75 1.5 1.667v8.666C22 15.25 21.325 16 20.5 16s-1.5-.75-1.5-1.667V5.667C19 4.75 19.675 4 20.5 4z"
        clip-rule="evenodd"
      />
    </svg>
  ) : (
    /*@ts-ignore*/
    <svg viewBox="0 0 24 24" width={width} height={height} fill="none">
      <path
        fill={disabled ? '#ccc' : fill}
        fill-rule="evenodd"
        d="M7.32 4.5h11.681c1.657 0 3 1.343 3 3v6c0 1.657-1.343 3-3 3h-2.289c-.13.274-.302.53-.512.756l-4.23 4.558-.012.012c-.856.893-2.26.898-3.137.014-.52-.533-.74-1.287-.597-2.016L8.763 17H6.051c-.542 0-1.078-.11-1.576-.323-2.03-.87-2.97-3.222-2.1-5.253l2.188-5.106C5.035 5.215 6.12 4.5 7.32 4.5zm9.51 2c.111.313.171.65.171 1v7h2c.553 0 1-.448 1-1v-6c0-.552-.447-1-1-1h-2.17zm-2.096 9.395c.172-.185.267-.428.267-.68V7.5c0-.552-.447-1-1-1h-6.68c-.401 0-.762.238-.92.606l-2.188 5.106c-.436 1.015.035 2.191 1.05 2.626.249.107.517.162.788.162h5.13l-.227 1.188-.766 4.015c-.019.094.007.182.058.235.082.081.19.082.266.007l4.222-4.55z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default LinedThumbsDown;
